export enum TenantType {
    AGENT = 'agent',
    SUPPLIER = 'supplier',
}

export enum ScrapeType {
    BRAND = 'brand',
    BRAND_WITH_DISCOVERY = 'brand_with_discovery',
    PROPERTY = 'property',
    SERVICE = 'service',
}

/**
 * Review sites a brand can link its profile on.
 * Mirrors `App\Enums\ReviewPlatform` — the values are the labels shown in
 * the platform select and stored on `brands.review_urls[*].platform`.
 */
export enum ReviewPlatform {
    TRIPADVISOR = 'TripAdvisor',
    GOOGLE_REVIEWS = 'Google Reviews',
    TRUSTPILOT = 'Trustpilot',
    BOOKING_COM = 'Booking.com',
    YELP = 'Yelp',
    OTHER = 'Other',
}

export enum OnboardingState {
    BRAND_FORM = 'BRAND_FORM',
    ADD_MORE_PROMPT = 'ADD_MORE_PROMPT',
    ASSIGN_UPLOADS = 'ASSIGN_UPLOADS',
}

export enum ValidationStep {
    TENANT_TYPE = 'tenant_type',
    BRAND = 'brand',
    SUBDOMAIN = 'subdomain',
}

export enum RateRequestStatus {
    Pending = 'pending',
    Accepted = 'accepted',
    Declined = 'declined',
    Expired = 'expired',
}

export enum RateShareStatus {
    Pending = 'pending',
    Accepted = 'accepted',
    Declined = 'declined',
}

/**
 * Per-recipient outcome returned by the bulk rate-request endpoint
 * (`RateRequestService::createBulkRequests`).
 */
export enum BulkRateRequestStatus {
    Sent = 'sent',
    SentExisting = 'sent_existing',
    SkippedAgent = 'skipped_agent',
    SkippedSelf = 'skipped_self',
    SkippedBlocked = 'skipped_blocked',
    SkippedDuplicate = 'skipped_duplicate',
}

/**
 * Sentinel codes the rate-request store endpoint returns under the
 * `supplier_email` error key for service-level rejections.
 */
export enum RateRequestEmailError {
    SelfRequest = 'self_request',
    AgentTarget = 'agent_target',
}

/**
 * Mirrors `App\Enums\PropertyFeature` — the feature-tag vocabulary the
 * extractor is asked for, the review screen offers, and Touri filters on.
 * Labels live under `rates.feature_tags.*`.
 */
export enum PropertyFeature {
    FAMILY_FRIENDLY = 'family_friendly',
    SPA = 'spa',
    POOL = 'pool',
    WIFI = 'wifi',
    GYM = 'gym',
    WHEELCHAIR_ACCESSIBLE = 'wheelchair_accessible',
    GAME_VIEWING = 'game_viewing',
    WATER_ACTIVITIES = 'water_activities',
    WALKING_SAFARI = 'walking_safari',
    CULTURAL_EXPERIENCE = 'cultural_experience',
    BIRDING = 'birding',
    MALARIA_FREE = 'malaria_free',
    BIG_FIVE = 'big_five',
    BEACH = 'beach',
    PRIVATE_PLUNGE_POOL = 'private_plunge_pool',
    ALL_SUITE = 'all_suite',
    ADULTS_ONLY = 'adults_only',
    ECO_LODGE = 'eco_lodge',
    FLY_IN_ONLY = 'fly_in_only',
}
